import React from "react";

function SmartImage({
  src,
  height = "auto",
  width = "auto",
  alt = "",
  style = {},
}) {
  let url = src;
  if (width !== "auto" || height !== "auto") {
    // replace url /500x500/ with /heightxwidth/
    url = url.replace(/\/500x500\//, `/${height}x${width}/`);
    return (
      <img
        src={url}
        alt={alt}
        style={{
          height: height === "auto" ? "auto" : `${height}px`,
          width: width === "auto" ? "auto" : `${width}px`,
          objectFit: "contain",
          ...style,
        }}
      />
    );
  }
  return <img src={url} alt={alt} className="img-fluid" style={style} />;
}

export default SmartImage;
